import * as React from 'react';
import { observer } from 'mobx-react';
import { Page, PageBody } from '../../../commonv3/components/atoms/pages/page';
import './subscriptionSuspensionInfoPage.module.scss';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { SubscriptionSuspensionConfirmationPageState } from './states/SubscriptionSuspensionConfirmationPageState';
import { Button } from '../../../commonv3/components/atoms/buttons/Button';
import { V3Routes } from '../../routes';
import { LoaderRow } from '../../components/atoms/layout/LoaderRow';
import { NotFoundPage } from '../../../mainv2/containers/common/NotFoundPage';
import { SurveyBody } from '../../components/molecules/surveys/SurveyBody';
import { LabelPrimary } from '../../components/atoms/labels/LabelPrimary';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';

type Props = {
    match: {
        params: {
            subscriptionCode: string;
        };
    };
};

@withNavigation(NavigationSpecs.none())
@observer
export class SubscriptionSuspensionConfirmationPage extends React.Component<Props> {
    pageState = new SubscriptionSuspensionConfirmationPageState();

    componentDidMount() {
        const { subscriptionCode } = this.props.match.params;
        this.pageState.init(subscriptionCode);
    }

    render() {
        const currentUser = GlobalStatesV3.currentUser.currentUser;
        const { subscription: subscriptionResource } = this.pageState;
        if (!this.pageState.initialized) {
            return <LoaderRow />;
        }
        if (subscriptionResource.isNotFound()) {
            return <NotFoundPage entityType="Subscription" />;
        }
        if (subscriptionResource.isError()) {
            GlobalStatesV3.routing.push(V3Routes.home());
            return null;
        }
        return (
            <Page styleName="page page-gray" id="subscription-suspension-complete-page">
                <PageBody styleName="page-body">
                    <div styleName="header">
                        <div styleName="header-name">休会処理が完了しました</div>
                    </div>
                    <SurveyBody>
                        <div styleName="attention attention-confirmation">
                            <div styleName="attention_text">
                                下記のメールアドレスに完了案内を送付いたしました。ご確認ください。
                            </div>

                            <div styleName="email">{currentUser.email}</div>

                            <LabelPrimary label="復帰の仕方" />
                            <div styleName="text">プランの確認/変更画面から復帰の手続きが可能です。</div>

                            <div styleName="hukki_image" />
                        </div>
                        <Button
                            styleName="submit-button"
                            type="primary"
                            size="l"
                            onClick={() => GlobalStatesV3.routing.push(V3Routes.plan())}
                        >
                            ホームに戻る
                        </Button>
                    </SurveyBody>
                </PageBody>
            </Page>
        );
    }
}
